import { Switch, Route, Redirect } from 'react-router-dom';

import AssetsNavigator from './AssetsNavigator';
import FormsNavigator from './FormsNavigator';
import SiteNavigator from './SiteNavigator';

function Navigator() {
  return (
    <Switch>
      <Route path="/" exact render={() => <Redirect to="/assets" />} />
      <Route path="/forms*" render={() => <FormsNavigator />} />
      <Route path="/assets*" render={() => <AssetsNavigator />} />
      <Route path="/site*" render={() => <SiteNavigator />} />
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  );
}

export default Navigator;
